var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-progress',{attrs:{"height":"2rem","max":_vm.max}},[_c('b-progress-bar',{attrs:{"value":_vm.value}},[(_vm.message)?_c('span',[_c('i',{staticClass:"fal fa-spinner fa-spin"}),_vm._v(" "+_vm._s(_vm.message))]):_vm._e()])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }